export function initTracking() {
  let trackingScript = document.createElement('script');

  trackingScript.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-PZ2FZGR';

  document.head.appendChild(trackingScript);

  window.dataLayer = window.dataLayer || [];

  function gtag() {
      dataLayer.push(arguments);
  }

  gtag('js', new Date());
  gtag('config', 'GTM-PZ2FZGR', { anonymize_ip: true });

  return {
      swipe: (label, step, maxStep, type, title) => {
          if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(JSON.stringify({
                  cmd: 'patronGAEvent',
                  args: {
                      action: 'Swipe',
                      label: label,
                      step: step,
                      maxStep: maxStep,
                      type: type,
                      title: title
                  }
              }));
          } else {
              window.parent.postMessage({
                  patronGAEvent: JSON.stringify({
                      event: 'Graphics',
                      eventInfo: {
                          action: 'Swipe',
                          label: label,
                          step: step,
                          maxStep: maxStep,
                          type: type,
                          title: title
                      }
                  })
              }, '*');
          }
      },
      buttonClick: (label, type, title) => {
          if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(JSON.stringify({
                  cmd: 'patronGAEvent',
                  args: {
                      action: 'Click',
                      label: label,
                      type: type,
                      title: title
                  }
              }));
          } else {
              window.parent.postMessage({
                  patronGAEvent: JSON.stringify({
                      event: 'Graphics',
                      eventInfo: {
                          action: 'Click',
                          label: label,
                          type: type,
                          title: title
                      }
                  })
              }, '*');
          }
      },
      mapClick: (label, type, title) => {
          if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(JSON.stringify({
                  cmd: 'patronGAEvent',
                  args: {
                      action: 'Click',
                      label: label,
                      step: undefined,
                      maxStep: undefined,
                      type: type,
                      title: title
                  }
              }));
          } else {
              window.parent.postMessage({
                  patronGAEvent: JSON.stringify({
                      event: 'Graphics',
                      eventInfo: {
                          action: 'Click',
                          label: label,
                          type: type,
                          title: title
                      }
                  })
              }, '*');
          }
      },
      twoStateSwipe: (label, type, title) => {
          if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(JSON.stringify({
                  cmd: 'patronGAEvent',
                  args: {
                      action: 'Swipe',
                      label: label,
                      step: undefined,
                      maxStep: undefined,
                      type: type,
                      title: title
                  }
              }));
          } else {
              window.parent.postMessage({
                  patronGAEvent: JSON.stringify({
                      event: 'Graphics',
                      eventInfo: {
                          action: 'Click',
                          label: label,
                          type: type,
                          title: title
                      }
                  })
              }, '*');
          }
      },
      enterIntoView: (label, type, title) => {
          if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(JSON.stringify({
                  cmd: 'patronGAEvent',
                  args: {
                      action: 'View',
                      label: label,
                      step: undefined,
                      maxStep: undefined,
                      type: type,
                      title: title
                  }
              }));
          } else {
              window.parent.postMessage({
                  patronGAEvent: JSON.stringify({
                      event: 'Graphics',
                      eventInfo: {
                          action: 'View',
                          label: label,
                          type: type,
                          title: title
                      }
                  })
              }, '*');
          }
      }
  };
}
